// Removed Firebase-related code for reference:
/*
import { doc, setDoc } from "firebase/firestore";

// In component props:
// const Careers = ({ auth, db, appId, signInAnonymously }) => {

// In handleSubmit:
// if (!auth.currentUser) await signInAnonymously(auth);
// const userId = auth.currentUser?.uid || "anonymous";
// const docRef = doc(
//   db,
//   `/artifacts/${appId}/users/${userId}/job_applications`,
//   `${Date.now()}`
// );
// await setDoc(docRef, { ...formData, timestamp: new Date() });
*/
import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import {
  FaBriefcase,
  FaCode,
  FaChartLine,
  FaGlobeAmericas,
  FaUserGraduate,
  FaHeart,
  FaClock,
  FaMapMarkerAlt,
  FaLaptop,
  FaHandshake,
  FaRocket,
  FaPaperPlane,
} from "react-icons/fa";
import generalApi from "../api/generalApi";

const Careers = () => {
  const [formData, setFormData] = useState({
    applicantName: "",
    applicantEmail: "",
    applicantPhone: "",
    jobPostingId: "",
    resumeUrl: "",
    coverLetter: "",
  });
  const [loading, setLoading] = useState(false);
  const [jobPostings, setJobPostings] = useState([]);

  useEffect(() => {
    generalApi.getJobPostings().then((jobs) => {
      if (Array.isArray(jobs)) setJobPostings(jobs);
    });
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.jobPostingId) {
      toast.error("Please select a position.");
      return;
    }
    setLoading(true);
    try {
      const result = await generalApi.applyForJob(formData);
      if (result.success) {
        toast.success(result.message || "🎉 Application submitted successfully! We'll be in touch soon.");
        setFormData({ applicantName: "", applicantEmail: "", applicantPhone: "", jobPostingId: "", resumeUrl: "", coverLetter: "" });
      } else {
        toast.error(result.message || "Failed to submit application. Please try again.");
      }
    } catch (err) {
      toast.error("Network error. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        fontFamily: "'Inter', 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
        background: "linear-gradient(135deg, #F5F5F5 0%, #FFFFFF 100%)",
        minHeight: "100vh",
        paddingBottom: "60px",
        marginTop: "50px",
      }}
    >
      <div
        style={{
          maxWidth: "1200px",
          margin: "0 auto",
          padding: "0 clamp(15px, 3vw, 20px)",
        }}
      >
        {/* Enhanced Header */}
        <header
          style={{
            textAlign: "center",
            paddingTop: "clamp(30px, 8vw, 50px)",
            paddingBottom: "clamp(20px, 5vw, 30px)",
            position: "relative",
          }}
        >
          {/* Decorative Elements */}
          <div
            style={{
              position: "absolute",
              top: "20px",
              right: "10%",
              width: "80px",
              height: "80px",
              borderRadius: "50%",
              background:
                "linear-gradient(135deg, rgba(238, 46, 36, 0.1) 0%, rgba(255, 196, 0, 0.1) 100%)",
              filter: "blur(20px)",
            }}
          />
          <div
            style={{
              position: "absolute",
              bottom: "15px",
              left: "15%",
              width: "60px",
              height: "60px",
              borderRadius: "50%",
              background:
                "linear-gradient(135deg, rgba(255, 196, 0, 0.15) 0%, rgba(238, 46, 36, 0.1) 100%)",
              filter: "blur(15px)",
            }}
          />

          <h1
            style={{
              fontSize: "clamp(2rem, 5vw, 2.8rem)",
              fontWeight: "800",
              color: "#2E2E2E",
              marginBottom: "10px",
              letterSpacing: "-0.8px",
              lineHeight: "1.1",
            }}
          >
            Careers at{" "}
            <span
              style={{
                background: "linear-gradient(135deg, #EE2E24 0%, #FFC400 100%)",
                backgroundClip: "text",
                WebkitBackgroundClip: "text",
                color: "transparent",
              }}
            >
              Trivana Hospitality
            </span>
          </h1>
          <p
            style={{
              color: "#2E2E2E",
              fontSize: "clamp(0.9rem, 2.2vw, 0.95rem)",
              maxWidth: "650px",
              margin: "0 auto",
              opacity: 0.8,
              fontWeight: "500",
              lineHeight: "1.5",
              padding: "0 15px",
            }}
          >
            Be part of a team redefining the future of hospitality. Let's grow,
            innovate, and build amazing experiences together.
          </p>
        </header>

        {/* Enhanced Open Positions */}
        <section style={{ marginBottom: "clamp(30px, 7vw, 50px)" }}>
          <h2
            style={{
              fontSize: "clamp(1.6rem, 4vw, 2.2rem)",
              fontWeight: "800",
              textAlign: "center",
              color: "#2E2E2E",
              marginBottom: "clamp(20px, 5vw, 30px)",
              letterSpacing: "-0.5px",
            }}
          >
            Open Positions
          </h2>

          <div
            style={{
              display: "grid",
              gridTemplateColumns:
                "repeat(auto-fit, minmax(min(100%, 280px), 1fr))",
              gap: "clamp(15px, 3vw, 20px)",
            }}
          >
            {/* Card 1 - Full Stack Developer */}
            <article
              style={{
                background: "#FFFFFF",
                padding: "clamp(18px, 4vw, 24px)",
                borderRadius: "14px",
                boxShadow: "0 4px 20px rgba(0,0,0,0.06)",
                border: "1px solid rgba(238, 46, 36, 0.1)",
                transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
                cursor: "pointer",
                position: "relative",
                overflow: "hidden",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-6px)";
                e.currentTarget.style.boxShadow =
                  "0 12px 30px rgba(238, 46, 36, 0.15)";
                e.currentTarget.style.borderColor = "#EE2E24";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = "0 4px 20px rgba(0,0,0,0.06)";
                e.currentTarget.style.borderColor = "rgba(238, 46, 36, 0.1)";
              }}
            >
              {/* Icon Badge */}
              <div
                style={{
                  display: "inline-flex",
                  padding: "8px",
                  background:
                    "linear-gradient(135deg, rgba(238, 46, 36, 0.1) 0%, rgba(255, 196, 0, 0.1) 100%)",
                  borderRadius: "10px",
                  marginBottom: "12px",
                }}
              >
                <FaCode style={{ fontSize: "1.2rem", color: "#EE2E24" }} />
              </div>

              <h3
                style={{
                  fontSize: "clamp(1rem, 2.5vw, 1.1rem)",
                  fontWeight: "800",
                  background:
                    "linear-gradient(135deg, #EE2E24 0%, #FFC400 100%)",
                  backgroundClip: "text",
                  WebkitBackgroundClip: "text",
                  color: "transparent",
                  marginBottom: "clamp(6px, 1.5vw, 8px)",
                  letterSpacing: "-0.5px",
                }}
              >
                Full Stack Developer
              </h3>

              <p
                style={{
                  color: "#2E2E2E",
                  marginBottom: "14px",
                  opacity: 0.7,
                  fontSize: "clamp(0.8rem, 2vw, 0.85rem)",
                  fontWeight: "500",
                  lineHeight: "1.5",
                }}
              >
                Help us shape our core platform. Code. Build. Impact.
              </p>

              <ul
                style={{
                  listStyle: "none",
                  padding: 0,
                  margin: 0,
                }}
              >
                {[
                  {
                    text: "Proficiency in React.js, Node.js, and MongoDB",
                    color: "#EE2E24",
                  },
                  {
                    text: "Experience with RESTful APIs and cloud solutions",
                    color: "#FFC400",
                  },
                  {
                    text: "Passion for problem-solving & clean code",
                    color: "#EE2E24",
                  },
                ].map((item, idx) => (
                  <li
                    key={idx}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                      color: "#2E2E2E",
                      fontSize: "clamp(0.75rem, 1.8vw, 0.8rem)",
                      marginBottom: "10px",
                      fontWeight: "500",
                      lineHeight: "1.4",
                    }}
                  >
                    <span
                      style={{
                        width: "6px",
                        height: "6px",
                        borderRadius: "50%",
                        background: item.color,
                        flexShrink: 0,
                      }}
                    />
                    {item.text}
                  </li>
                ))}
              </ul>
            </article>

            {/* Card 2 - Business Development Manager */}
            <article
              style={{
                background: "#FFFFFF",
                padding: "clamp(18px, 4vw, 24px)",
                borderRadius: "14px",
                boxShadow: "0 4px 20px rgba(0,0,0,0.06)",
                border: "1px solid rgba(238, 46, 36, 0.1)",
                transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
                cursor: "pointer",
                position: "relative",
                overflow: "hidden",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-6px)";
                e.currentTarget.style.boxShadow =
                  "0 12px 30px rgba(238, 46, 36, 0.15)";
                e.currentTarget.style.borderColor = "#FFC400";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = "0 4px 20px rgba(0,0,0,0.06)";
                e.currentTarget.style.borderColor = "rgba(238, 46, 36, 0.1)";
              }}
            >
              {/* Icon Badge */}
              <div
                style={{
                  display: "inline-flex",
                  padding: "8px",
                  background:
                    "linear-gradient(135deg, rgba(255, 196, 0, 0.1) 0%, rgba(238, 46, 36, 0.1) 100%)",
                  borderRadius: "10px",
                  marginBottom: "12px",
                }}
              >
                <FaChartLine style={{ fontSize: "1.2rem", color: "#FFC400" }} />
              </div>

              <h3
                style={{
                  fontSize: "clamp(1rem, 2.5vw, 1.1rem)",
                  fontWeight: "800",
                  background:
                    "linear-gradient(135deg, #FFC400 0%, #EE2E24 100%)",
                  backgroundClip: "text",
                  WebkitBackgroundClip: "text",
                  color: "transparent",
                  marginBottom: "clamp(6px, 1.5vw, 8px)",
                  letterSpacing: "-0.5px",
                }}
              >
                Business Development Manager
              </h3>

              <p
                style={{
                  color: "#2E2E2E",
                  marginBottom: "14px",
                  opacity: 0.7,
                  fontSize: "clamp(0.8rem, 2vw, 0.85rem)",
                  fontWeight: "500",
                  lineHeight: "1.5",
                }}
              >
                Drive growth by connecting with hoteliers & restaurateurs.
              </p>

              <ul
                style={{
                  listStyle: "none",
                  padding: 0,
                  margin: 0,
                }}
              >
                {[
                  {
                    text: "Proven track record in B2B sales or partnerships",
                    color: "#FFC400",
                  },
                  {
                    text: "Excellent communication & networking skills",
                    color: "#EE2E24",
                  },
                  {
                    text: "Understanding of Indian hospitality landscape",
                    color: "#FFC400",
                  },
                ].map((item, idx) => (
                  <li
                    key={idx}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                      color: "#2E2E2E",
                      fontSize: "clamp(0.75rem, 1.8vw, 0.8rem)",
                      marginBottom: "10px",
                      fontWeight: "500",
                      lineHeight: "1.4",
                    }}
                  >
                    <span
                      style={{
                        width: "6px",
                        height: "6px",
                        borderRadius: "50%",
                        background: item.color,
                        flexShrink: 0,
                      }}
                    />
                    {item.text}
                  </li>
                ))}
              </ul>
            </article>
          </div>
        </section>

        {/* Enhanced Why Join Section */}
        <section style={{ marginBottom: "50px" }}>
          <h2
            style={{
              fontSize: "clamp(1.6rem, 4vw, 2.2rem)",
              fontWeight: "800",
              textAlign: "center",
              color: "#2E2E2E",
              marginBottom: "30px",
              letterSpacing: "-0.5px",
            }}
          >
            Why Join Trivana?
          </h2>

          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))",
              gap: "20px",
            }}
          >
            {[
              {
                icon: <FaGlobeAmericas />,
                title: "Global Impact",
                desc: "Work on products that shape the hospitality industry worldwide.",
                color: "#EE2E24",
              },
              {
                icon: <FaUserGraduate />,
                title: "Growth & Mentorship",
                desc: "Clear career paths, regular feedback, and hands-on mentorship.",
                color: "#FFC400",
              },
              {
                icon: <FaHeart />,
                title: "Vibrant Culture",
                desc: "Innovative, inclusive, and fun — we celebrate wins together.",
                color: "#EE2E24",
              },
            ].map((item, index) => (
              <div
                key={index}
                style={{
                  background: "#FFFFFF",
                  padding: "clamp(18px, 4vw, 24px)",
                  borderRadius: "14px",
                  boxShadow: "0 4px 20px rgba(0,0,0,0.06)",
                  border: "1px solid rgba(238, 46, 36, 0.1)",
                  transition: "all 0.3s ease",
                  textAlign: "center",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-4px)";
                  e.currentTarget.style.boxShadow =
                    "0 8px 25px rgba(238, 46, 36, 0.12)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow =
                    "0 4px 20px rgba(0,0,0,0.06)";
                }}
              >
                <div
                  style={{
                    fontSize: "clamp(1.6rem, 4vw, 2rem)",
                    color: item.color,
                    marginBottom: "14px",
                  }}
                >
                  {item.icon}
                </div>
                <h3
                  style={{
                    fontSize: "clamp(1rem, 2.5vw, 1.1rem)",
                    fontWeight: "800",
                    color: "#2E2E2E",
                    marginBottom: "clamp(6px, 1.5vw, 8px)",
                    letterSpacing: "-0.3px",
                  }}
                >
                  {item.title}
                </h3>
                <p
                  style={{
                    color: "#2E2E2E",
                    opacity: 0.7,
                    fontSize: "clamp(0.8rem, 2vw, 0.85rem)",
                    lineHeight: "1.5",
                    fontWeight: "500",
                  }}
                >
                  {item.desc}
                </p>
              </div>
            ))}
          </div>
        </section>

        {/* Enhanced Perks & Benefits */}
        <section style={{ marginBottom: "50px" }}>
          <h2
            style={{
              fontSize: "clamp(1.4rem, 4vw, 1.8rem)",
              fontWeight: "800",
              textAlign: "center",
              color: "#2E2E2E",
              marginBottom: "clamp(20px, 5vw, 28px)",
              letterSpacing: "-0.8px",
            }}
          >
            Perks & Benefits
          </h2>

          <div
            style={{
              display: "grid",
              gridTemplateColumns:
                "repeat(auto-fit, minmax(min(100%, 140px), 1fr))",
              gap: "clamp(10px, 2.5vw, 14px)",
            }}
          >
            {[
              { icon: <FaClock />, text: "Flexible Hours" },
              { icon: <FaMapMarkerAlt />, text: "Remote Friendly" },
              { icon: <FaBriefcase />, text: "Learning Budget" },
              { icon: <FaRocket />, text: "Team Offsites" },
              { icon: <FaHeart />, text: "Health Cover" },
              { icon: <FaHandshake />, text: "Fast Growth" },
            ].map((perk, index) => (
              <div
                key={index}
                style={{
                  background:
                    "linear-gradient(135deg, rgba(238, 46, 36, 0.05) 0%, rgba(255, 196, 0, 0.05) 100%)",
                  backdropFilter: "blur(10px)",
                  padding: "clamp(12px, 3vw, 16px) clamp(10px, 2.5vw, 12px)",
                  borderRadius: "10px",
                  border: "1px solid rgba(238, 46, 36, 0.1)",
                  textAlign: "center",
                  transition: "all 0.3s ease",
                  cursor: "pointer",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background =
                    "linear-gradient(135deg, #EE2E24 0%, #FFC400 100%)";
                  e.currentTarget.style.color = "#FFFFFF";
                  e.currentTarget.style.transform =
                    "translateY(-4px) scale(1.05)";
                  e.currentTarget.style.boxShadow =
                    "0 8px 20px rgba(238, 46, 36, 0.3)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background =
                    "linear-gradient(135deg, rgba(238, 46, 36, 0.05) 0%, rgba(255, 196, 0, 0.05) 100%)";
                  e.currentTarget.style.color = "#2E2E2E";
                  e.currentTarget.style.transform = "translateY(0) scale(1)";
                  e.currentTarget.style.boxShadow = "none";
                }}
              >
                <div
                  style={{
                    fontSize: "clamp(1.1rem, 3vw, 1.3rem)",
                    marginBottom: "6px",
                  }}
                >
                  {perk.icon}
                </div>
                <div
                  style={{
                    fontSize: "clamp(0.75rem, 1.8vw, 0.8rem)",
                    fontWeight: "700",
                    letterSpacing: "-0.2px",
                  }}
                >
                  {perk.text}
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* Enhanced Application Form */}
        <section style={{ display: "flex", justifyContent: "center" }}>
          <div
            style={{
              width: "100%",
              maxWidth: "900px",
              background: "#FFFFFF",
              padding: "clamp(20px, 5vw, 32px)",
              borderRadius: "16px",
              boxShadow: "0 8px 30px rgba(0,0,0,0.08)",
              border: "1px solid rgba(238, 46, 36, 0.1)",
              position: "relative",
              overflow: "hidden",
            }}
          >
            {/* Decorative Corner */}
            <div
              style={{
                position: "absolute",
                top: 0,
                right: 0,
                width: "120px",
                height: "120px",
                background:
                  "linear-gradient(135deg, rgba(238, 46, 36, 0.05) 0%, rgba(255, 196, 0, 0.05) 100%)",
                borderRadius: "0 0 0 100%",
              }}
            />

            {/* Form Header */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "clamp(8px, 2vw, 12px)",
                marginBottom: "clamp(16px, 4vw, 24px)",
                position: "relative",
                zIndex: 1,
              }}
            >
              <div
                style={{
                  background:
                    "linear-gradient(135deg, #EE2E24 0%, #FFC400 100%)",
                  borderRadius: "10px",
                  padding: "10px",
                  color: "white",
                  boxShadow: "0 4px 15px rgba(238, 46, 36, 0.3)",
                }}
              >
                <FaPaperPlane style={{ fontSize: "1.1rem" }} />
              </div>
              <div>
                <h2
                  style={{
                    fontSize: "clamp(1.2rem, 3.5vw, 1.5rem)",
                    fontWeight: "800",
                    color: "#2E2E2E",
                    margin: 0,
                    letterSpacing: "-0.5px",
                  }}
                >
                  Apply Now
                </h2>
                <p
                  style={{
                    color: "#2E2E2E",
                    fontSize: "clamp(0.8rem, 2vw, 0.85rem)",
                    margin: "4px 0 0 0",
                    opacity: 0.6,
                    fontWeight: "500",
                  }}
                >
                  Join our team and make an impact
                </p>
              </div>
            </div>

            <form
              onSubmit={handleSubmit}
              style={{
                display: "grid",
                gap: "16px",
                position: "relative",
                zIndex: 1,
              }}
            >
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns:
                    "repeat(auto-fit, minmax(min(100%, 200px), 1fr))",
                  gap: "clamp(12px, 3vw, 16px)",
                }}
              >
                <div>
                  <label
                    style={{
                      display: "block",
                      color: "#2E2E2E",
                      marginBottom: "6px",
                      fontWeight: "700",
                      fontSize: "clamp(0.8rem, 2vw, 0.85rem)",
                      letterSpacing: "-0.2px",
                    }}
                  >
                    Full Name
                  </label>
                  <input
                    name="applicantName"
                    value={formData.applicantName}
                    onChange={handleChange}
                    style={{
                      width: "100%",
                      padding:
                        "clamp(10px, 2.5vw, 12px) clamp(14px, 3vw, 16px)",
                      borderRadius: "8px",
                      border: "2px solid #E8E8E8",
                      fontSize: "clamp(0.85rem, 2vw, 0.9rem)",
                      background: "#FAFAFA",
                      transition: "all 0.3s ease",
                      outline: "none",
                      fontWeight: "500",
                      fontFamily:
                        "'Inter', 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
                    }}
                    onFocus={(e) => {
                      e.target.style.borderColor = "#EE2E24";
                      e.target.style.background = "#FFFFFF";
                      e.target.style.boxShadow =
                        "0 0 0 4px rgba(238, 46, 36, 0.08)";
                    }}
                    onBlur={(e) => {
                      e.target.style.borderColor = "#E8E8E8";
                      e.target.style.background = "#FAFAFA";
                      e.target.style.boxShadow = "none";
                    }}
                    required
                  />
                </div>
                <div>
                  <label
                    style={{
                      display: "block",
                      color: "#2E2E2E",
                      marginBottom: "6px",
                      fontWeight: "700",
                      fontSize: "clamp(0.8rem, 2vw, 0.85rem)",
                      letterSpacing: "-0.2px",
                    }}
                  >
                    Email Address
                  </label>
                  <input
                    name="applicantEmail"
                    type="email"
                    value={formData.applicantEmail}
                    onChange={handleChange}
                    style={{
                      width: "100%",
                      padding:
                        "clamp(10px, 2.5vw, 12px) clamp(14px, 3vw, 16px)",
                      borderRadius: "8px",
                      border: "2px solid #E8E8E8",
                      fontSize: "clamp(0.85rem, 2vw, 0.9rem)",
                      background: "#FAFAFA",
                      transition: "all 0.3s ease",
                      outline: "none",
                      fontWeight: "500",
                      fontFamily:
                        "'Inter', 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
                    }}
                    onFocus={(e) => {
                      e.target.style.borderColor = "#EE2E24";
                      e.target.style.background = "#FFFFFF";
                      e.target.style.boxShadow =
                        "0 0 0 4px rgba(238, 46, 36, 0.08)";
                    }}
                    onBlur={(e) => {
                      e.target.style.borderColor = "#E8E8E8";
                      e.target.style.background = "#FAFAFA";
                      e.target.style.boxShadow = "none";
                    }}
                    required
                  />
                </div>
              </div>

              <div
                style={{
                  display: "grid",
                  gridTemplateColumns:
                    "repeat(auto-fit, minmax(min(100%, 200px), 1fr))",
                  gap: "clamp(14px, 3.5vw, 18px)",
                }}
              >
                <div>
                  <label
                    style={{
                      display: "block",
                      color: "#2E2E2E",
                      marginBottom: "8px",
                      fontWeight: "700",
                      fontSize: "clamp(0.85rem, 2vw, 0.9rem)",
                    }}
                  >
                    Phone Number
                  </label>
                  <input
                    name="applicantPhone"
                    value={formData.applicantPhone}
                    onChange={handleChange}
                    style={{
                      width: "100%",
                      padding:
                        "clamp(10px, 2.5vw, 14px) clamp(14px, 3vw, 18px)",
                      borderRadius: "10px",
                      border: "2px solid #E8E8E8",
                      fontSize: "clamp(0.85rem, 2vw, 0.95rem)",
                      background: "#FAFAFA",
                      transition: "all 0.3s ease",
                      outline: "none",
                      fontWeight: "500",
                      fontFamily:
                        "'Inter', 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
                    }}
                    onFocus={(e) => {
                      e.target.style.borderColor = "#EE2E24";
                      e.target.style.background = "#FFFFFF";
                      e.target.style.boxShadow =
                        "0 0 0 4px rgba(238, 46, 36, 0.08)";
                    }}
                    onBlur={(e) => {
                      e.target.style.borderColor = "#E8E8E8";
                      e.target.style.background = "#FAFAFA";
                      e.target.style.boxShadow = "none";
                    }}
                    required
                  />
                </div>
                <div>
                  <label
                    style={{
                      display: "block",
                      color: "#2E2E2E",
                      marginBottom: "8px",
                      fontWeight: "700",
                      fontSize: "clamp(0.85rem, 2vw, 0.9rem)",
                    }}
                  >
                    Position of Interest
                  </label>
                  <select
                    name="jobPostingId"
                    value={formData.jobPostingId}
                    onChange={handleChange}
                    style={{
                      width: "100%",
                      padding:
                        "clamp(10px, 2.5vw, 14px) clamp(14px, 3vw, 18px)",
                      borderRadius: "10px",
                      border: "2px solid #E8E8E8",
                      fontSize: "clamp(0.85rem, 2vw, 0.95rem)",
                      background: "#FAFAFA",
                      transition: "all 0.3s ease",
                      outline: "none",
                      fontWeight: "500",
                      cursor: "pointer",
                    }}
                    onFocus={(e) => {
                      e.target.style.borderColor = "#EE2E24";
                      e.target.style.background = "#FFFFFF";
                      e.target.style.boxShadow =
                        "0 0 0 4px rgba(238, 46, 36, 0.08)";
                    }}
                    onBlur={(e) => {
                      e.target.style.borderColor = "#E8E8E8";
                      e.target.style.background = "#FAFAFA";
                      e.target.style.boxShadow = "none";
                    }}
                    required
                  >
                    <option value="">Select a position</option>
                    {jobPostings.length > 0
                      ? jobPostings.map((job) => (
                          <option key={job.id} value={job.id}>
                            {job.jobTitle}{job.department ? ` — ${job.department}` : ""}
                          </option>
                        ))
                      : [
                          <option key="fsd" value="fsd">Full Stack Developer</option>,
                          <option key="bdm" value="bdm">Business Development Manager</option>,
                          <option key="fi" value="fi">Frontend Intern</option>,
                          <option key="bi" value="bi">Backend Intern</option>,
                          <option key="ux" value="ux">UI/UX Designer</option>,
                          <option key="mi" value="mi">Marketing Intern</option>,
                          <option key="fsi" value="fsi">Full-Stack Intern</option>,
                          <option key="other" value="other">Other</option>,
                        ]}
                  </select>
                </div>
              </div>

              <div>
                <label
                  style={{
                    display: "block",
                    color: "#2E2E2E",
                    marginBottom: "8px",
                    fontWeight: "700",
                    fontSize: "clamp(0.85rem, 2vw, 0.9rem)",
                  }}
                >
                  Resume Link (Google Drive / Dropbox)
                </label>
                <input
                  name="resumeUrl"
                  type="url"
                  value={formData.resumeUrl}
                  onChange={handleChange}
                  placeholder="https://drive.google.com/your-resume-link"
                  style={{
                    width: "100%",
                    padding: "clamp(10px, 2.5vw, 14px) clamp(14px, 3vw, 18px)",
                    borderRadius: "10px",
                    border: "2px solid #E8E8E8",
                    fontSize: "clamp(0.85rem, 2vw, 0.95rem)",
                    background: "#FAFAFA",
                    transition: "all 0.3s ease",
                    outline: "none",
                    fontWeight: "500",
                  }}
                  onFocus={(e) => {
                    e.target.style.borderColor = "#EE2E24";
                    e.target.style.background = "#FFFFFF";
                    e.target.style.boxShadow =
                      "0 0 0 4px rgba(238, 46, 36, 0.08)";
                  }}
                  onBlur={(e) => {
                    e.target.style.borderColor = "#E8E8E8";
                    e.target.style.background = "#FAFAFA";
                    e.target.style.boxShadow = "none";
                  }}
                  required
                />
              </div>

              <button
                type="submit"
                disabled={loading}
                style={{
                  width: "100%",
                  background: loading
                    ? "linear-gradient(135deg, #BDBDBD 0%, #9E9E9E 100%)"
                    : "linear-gradient(135deg, #EE2E24 0%, #FFC400 100%)",
                  color: "#fff",
                  fontWeight: "700",
                  fontSize: "clamp(0.9rem, 2.5vw, 1rem)",
                  border: "none",
                  borderRadius: "10px",
                  padding: "clamp(12px, 3vw, 16px) 0",
                  cursor: loading ? "not-allowed" : "pointer",
                  boxShadow: "0 6px 20px rgba(238, 46, 36, 0.3)",
                  transition: "all 0.3s ease",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "10px",
                  letterSpacing: "0.3px",
                }}
                onMouseEnter={(e) => {
                  if (!loading) {
                    e.target.style.transform = "translateY(-2px)";
                    e.target.style.boxShadow =
                      "0 8px 25px rgba(238, 46, 36, 0.4)";
                  }
                }}
                onMouseLeave={(e) => {
                  if (!loading) {
                    e.target.style.transform = "translateY(0)";
                    e.target.style.boxShadow =
                      "0 6px 20px rgba(238, 46, 36, 0.3)";
                  }
                }}
              >
                {loading ? "Submitting..." : "Submit Application"}
              </button>
            </form>
          </div>
        </section>

        <style>{`
          html, body, #root { overflow-x: hidden; }
          * { box-sizing: border-box; }
          .career-title {
            font-size: clamp(1.6rem, 6vw, 3.4rem);
            line-height: 1.02;
            white-space: normal;
            word-break: break-word;
            overflow-wrap: anywhere;
            margin: 0 auto;
            max-width: 100%;
          }
          .min-w-0 { min-width: 0; }
          .grid > * { min-width: 0; }
        `}</style>
      </div>
    </div>
  );
};

export default Careers;
